import React from 'react';

export type AsyncSubscribedRef = {
  /**
   * @deprecated isMounted 사용.
   */
  current: boolean;

  /**
   * Mount 상태 여부.
   */
  isMounted: () => boolean;

  /**
   * unmount 시 콜백.
   */
  unsubscriber?: () => void;
};

export type AsyncEffectCallback = (subscribedRef: AsyncSubscribedRef) => Promise<void>;

/**
 * 비동기 Effect 사용 시, mount 상태도 같이 받도록 합니다.
 */
export const useAsyncEffect = (effect: AsyncEffectCallback, deps?: React.DependencyList) => {
  React.useEffect(() => {
    let mounted = true;

    const subscribedRef: AsyncSubscribedRef = {
      current: true,
      isMounted: () => mounted,
    };

    void effect(subscribedRef);

    return () => {
      mounted = false;
      subscribedRef.current = false;
      subscribedRef.unsubscriber?.();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
